<template>
  <div
    :class="computedClassList"
    class="jade-status-tracker"
  >
    <div class="jade-status-tracker__step-container">
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="`is-${item.status}`"
        class="jade-status-tracker__step"
      >
        <div class="jade-status-tracker__marker-container">
          <div class="jade-status-tracker__marker">
            <jade-status-tracker-icon
              :use="item.status"
            ></jade-status-tracker-icon>
          </div>
          <div class="jade-status-tracker__path-line"></div>
        </div>
        <jade-status-tracker-content
          :description="item.description"
          :link="item?.link"
          :label="item.label"
          :status="item.status"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DIRECTION_ENUM from '../enums/direction.enum'

export default {
  name: 'JadeStatusTracker',
  components: {
    'jade-status-tracker-content': () =>
      import('./JadeStatusTrackerContent/index.vue'),
    'jade-status-tracker-icon': () =>
      import('./JadeStatusTrackerIcon/index.vue')
  },

  props: {
    direction: {
      type: String,
      validation: direction =>
        Object.values(DIRECTION_ENUM).includes(direction),
      default: DIRECTION_ENUM.HORIZONTAL
    },
    items: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      isDesktopView: true
    }
  },

  computed: {
    computedClassList () {
      const direction = this.isDesktopView
        ? this.direction
        : DIRECTION_ENUM.VERTICAL
      return [`is-${direction}`]
    }
  },

  created () {
    window.addEventListener('resize', this.checkIfDesktopView)
    this.checkIfDesktopView()
  },
  destroyed () {
    window.removeEventListener('resize', this.checkIfDesktopView)
  },
  methods: {
    checkIfDesktopView () {
      this.isDesktopView = window.innerWidth > 768
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/status-tracker.css';
@import '@stone-payments/jade-design-tokens/stone/color.css';
@import '@stone-payments/jade-design-tokens/pagarme/component/status-tracker.css';
@import '@stone-payments/jade/css/text.css';
</style>
